import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=69d033f8&"
import script from "./NotificationPage.vue?vue&type=script&lang=js&"
export * from "./NotificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports